import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Table from '@vcomponents/AppTable';
import { createColumnHelper } from '@tanstack/react-table';
import './style.scss';

const JobDetailsModal = () => {
  const { payload } = useSelector((state) => state.modal);

  const columnHelper = createColumnHelper();

  const detailsTableData = useMemo(() => {
    const jobData = payload?.jobData ? [payload.jobData] : [];

    return {
      data: jobData?.map((item, index) => ({
        id: index + 1,
        ...item,
        user_emails: item?.user_emails?.join(', ') || '',
        user_ids: item?.user_ids?.join(', ') || '',
      })),
      from: 1,
      to: jobData.length,
      total: jobData.length,
      pageIndex: 0,
      pageSize: jobData.length,
      pageCount: 1,
      loading: false,
    };
  }, [payload]);

  const JobDetailColumns = () => [
    columnHelper.accessor('ticket_number', {
      header: 'Ticket Number',
      cell: ({ getValue }) => (
        <div className='text-secondary font-weight-bold number-column'>
          {getValue()}
        </div>
      ),
    }),
    columnHelper.accessor('user_emails', {
      header: 'User Emails',
      cell: ({ getValue }) => (
        <div className='text-secondary font-weight-bold emails-column'>
          {getValue()}
        </div>
      ),
    }),
  ];

  return (
    <div className='job-details-table'>
      <Table
        key='job-details-table'
        state={{
          columns: JobDetailColumns(),
          data: detailsTableData,
        }}
        pagination={false}
        actions={{}}
      />
    </div>
  );
};

export default JobDetailsModal;
